import type FeatureFlagManager from './FeatureFlagManager';
import OnPremFeatureFlagManager from './OnPremFeatureFlagManager';
import ProteusFeatureFlagManager from './ProteusFeatureFlagManager';

export interface FeatureFlagParams {
    isOnPrem: boolean;
    organizationId: string;
    tenantId: string;
    userKey?: string;
    userEmail?: string;
    flags?: string;
}

export default class FeatureFlagFactory {
    static getInstance({
        isOnPrem, organizationId, tenantId, userKey, userEmail, flags,
    }: FeatureFlagParams): FeatureFlagManager | null {
        if (isOnPrem) {
            return OnPremFeatureFlagManager.initialize(flags);
        }
        return ProteusFeatureFlagManager.initialize(organizationId, tenantId, userKey, userEmail);
    }
}
